'use client';

import { useChangeLocale } from '@/locales/client';
import type { ReactElement } from 'react';
import { LanguagesIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export default function ChangeLocalization(): ReactElement {
  const changeLocale = useChangeLocale();

  const onClick = (locale: 'en' | 'ru' | 'de' | 'fr'): void => {
    changeLocale(locale);
    localStorage.setItem('locale', locale);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <LanguagesIcon className="h-[1.3rem] w-[1.3rem]" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onClick('en')}>English - EN</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onClick('de')}>Deutsch - DE</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onClick('fr')}>Français - FR</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onClick('ru')}>Русский - RU</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
